import script from "./DocumentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentItem.vue?vue&type=script&setup=true&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=8589b884&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8589b884"]])

export default __exports__